import axios 	from "axios";
import Api 		from "@/services/Api";
import sha1 	from "sha1";

export default {
	async getPing() {
		return Api().get("", { params: { storechain: "tls-app-hads" }})
			.then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async getMessages() {
		return Api().get("/messages?limit=100")
			.then(response => response.data)
			.catch(error => Promise.reject(error));
	},

	async authenticateV1(email, password) {
		axios.create({
			baseURL: `${process.env.VUE_APP_PRO_URL}/api/v1`,
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json"
			}
		})({
			url: "/sessions/login",
			method: "post",
			data: {
				pro: {
					email: email,
					password: sha1(password)
				}
			}
		}).then().catch(error => {
			return Promise.reject(error);
		});
	},

	async authenticate(email, password) {
		var data = new FormData();
		data.set("email", email);
		data.set("password", password);
		data.set("resource_name", "Pro");

		return Api()({
			method: "post",
			data: data,
			url: "/tls/sessions"
		}).then(response => {
			return response.data;
		}).catch(error => {
			return Promise.reject(error);
		});
	}
};
